import React from "react";

export default function SQLServer_ABS() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_ABS</h1>
      <p>This is the SQLServer_ABS component generated from the SQL JSON.</p>
    </div>
  );
}
